import React, { useState, useEffect } from "react";
import axios from "axios";

import moment from "moment";

import _ from "lodash";

import Aside from "../../components/Aside/Aside";
import {TailSpin} from "react-loader-spinner";
import { GivenTraffic, Units, Profile } from "../../types";
import { Navigate } from "react-router-dom";

const ReportTraffic: React.FC = () => {
  const [profile, setProfile] = useState<Profile>();
  const [traffic, setTraffic] = useState<GivenTraffic>();
  const [prevTraffic, setPrevTraffic] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenPrev, setIsOpenPrev] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadedFullTraffic, setIsLoadedFullTraffic] = useState(false);
  const [isLoadedFullReport, setIsLoadedFullReport] = useState(true);
  const [errors, setErrors] = React.useState("");
  const [units, setUnits] = useState<Units>();

  useEffect(() => {
    async function fetchTariff() {
      const { data: profile } = await axios.get("v1/profile/info");
      setProfile(profile);
      axios.get("v1/traffic/traffic/given").then((res) => {
        setTraffic(res.data);
      });
      axios
        .post("v1/traffic/traffic/units", {
          user_id: profile?.id,
        })
        .then((res) => {
          setUnits(res.data);
          setIsLoaded(false);
          setIsOpen(true);
        });
    }
    fetchTariff();
  }, []);

  if (profile?.tariffName === "Стартовый Ямал") return <Navigate to="/inet/activate" />;

  const getTraffic = () => {
    setIsLoadedFullReport(false);
    setIsLoadedFullTraffic(true);
    try {
      var date = new Date();
      const Onedate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      const twoDate = new Date(date.getFullYear(), date.getMonth(), 1, 0);
      const prevStart = (Onedate.getTime() / 1000).toFixed(0);
      const prevEnd = (twoDate.getTime() / 1000).toFixed(0);

      axios
        .post("v1/traffic/traffic/prev", {
          prev_start: 1609448400,
          prev_end: parseFloat(prevEnd),
        })
        .then((res) => {
          let grouped_items = _.groupBy(
            res.data.report.sort((a: any, b: any) =>
              moment(b.date).diff(a.date)
            ),
            (b) => moment.unix(b.date).startOf("month").format("MMMM Y")
          );
          setPrevTraffic(
            Object.entries(grouped_items).map(([key, items]) => ({
              date: key,
              traffic: items.reduce(
                (acc: any, item: any) => {
                  acc.incoming += item.incoming;
                  acc.outgoing += item.outgoing;
                  return acc;
                },
                { incoming: 0, outgoing: 0 }
              ),
            }))
          );
          setIsLoadedFullTraffic(false);
          setIsOpenPrev(true);
        });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside />
      <div style={{ width: "100%" }}>
        <main data-v-dde546dc="" className="el-main">
          <div
            data-v-3563ec52=""
            data-v-dde546dc=""
            className="reports-payments"
          >
            <h1 data-v-3563ec52="">Отчет по трафику</h1>

            {isLoaded ? (
              <div data-v-dde546dc="" className="el-main">
                <div
                  data-v-dde546dc=""
                  className="dashboard justify-center align-center flex"
                >
                  <TailSpin
                    color="#d6f1dc"
                    height={100}
                    width={100}
                  />
                </div>
              </div>
            ) : null}
            {isOpen ? (
              <div data-v-3563ec52="" className="loading-container">
                <div data-v-3563ec52="" className="mt-1">
                  <div
                    data-v-3563ec52=""
                    className="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"
                  >
                    <div className="hidden-columns">
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                      <div data-v-3563ec52=""></div>
                    </div>
                    <div className="el-table__header-wrapper">
                      <table
                        cellSpacing="0"
                        cellPadding="0"
                        className="el-table__header"
                        style={{ width: "100%" }}
                      >
                        <colgroup>
                          <col className="el-table_7_column_23" width="345" />
                          <col className="el-table_7_column_24" width="190" />
                          {/* <col className="el-table_7_column_25" width="257" /> */}
                          <col className="el-table_7_column_26" width="325" />
                          <col className="el-table_7_column_27" width="171" />
                          <col className="gutter" width="0" />
                        </colgroup>
                        <thead className="has-gutter">
                          <tr className="">
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_23 ascending    is-leaf is-sortable"
                            >
                              <div className="cell">Трафик</div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_24     is-leaf is-sortable"
                            >
                              <div className="cell">Обьем</div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_26     is-leaf"
                            >
                              <div className="cell">Стоимость за МБ</div>
                            </th>
                            <th
                              rowSpan={1}
                              colSpan={1}
                              className="el-table_7_column_27  is-right   is-leaf is-sortable"
                            >
                              <div className="cell">Сумма</div>
                            </th>
                            <th
                              className="gutter"
                              style={{ width: 0, display: "none" }}
                            ></th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div className="el-table__body-wrapper is-scrolling-none">
                      <table
                        cellSpacing="0"
                        cellPadding="0"
                        className="el-table__body"
                        style={{ width: 1030 }}
                      >
                        <colgroup>
                          <col className="el-table_7_column_23" width="300" />
                          <col className="el-table_7_column_24" width="171" />
                          <col className="el-table_7_column_26" width="257" />
                          <col className="el-table_7_column_27" width="171" />
                        </colgroup>
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            textAlign: "left",
                            fontSize: "18px",
                            fontWeight: 300,
                            width: "500%",
                            background: "#f4fcf6",
                            borderBottom: "1px solid #d6f1dc;",
                            padding: "5px 10px 10px 10px",
                            color: "#fff",
                            backgroundColor: "#1294a0",
                            borderColor: "#1294a0",
                          }}
                        >
                          Текущий месяц
                        </p>
                        <tbody>
                          <>
                            {/* Входящий трафик */}
                            <tr
                              className="el-table__row"
                              style={{ background: "#d6f1dc", color: "black" }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">Входящий</div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {traffic?.trafficIncNull.toFixed(0)} Мб
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell">
                                  {traffic?.baseCostIncNull} ₽
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell">
                                  {traffic?.chargeIncNull} ₽
                                </div>
                              </td>
                            </tr>

                            {/* Исходящий трафик */}
                            <tr
                              className="el-table__row"
                              style={{ background: "#d6f1dc", color: "black" }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">Исходящий</div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {traffic?.trafficOutNull.toFixed(0)} Мб
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell">
                                  {traffic?.baseCostOutNull} ₽
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell">
                                  {traffic?.chargeOutNull} ₽
                                </div>
                              </td>
                            </tr>

                            {/* Остаток предоплаченного входящего */}
                            <tr
                              className="el-table__row"
                              style={{
                                background: "#f0d99c",
                                color: "black",
                                backgroundColor: "#f0d99c",
                              }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">
                                  Остаток предоплаченного входящего
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {units?.incoming ? (
                                    <span>
                                      {units?.incoming?.toFixed(2)} Мб
                                    </span>
                                  ) : (
                                    <small
                                      style={{ fontWeight: 400, fontSize: 15 }}
                                    >
                                      Нет
                                    </small>
                                  )}
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell"></div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell"></div>
                              </td>
                            </tr>
                            {/* Остаток предоплаченного исходящего */}
                            <tr
                              className="el-table__row"
                              style={{
                                background: "#f0d99c",
                                color: "black",
                                backgroundColor: "#f0d99c",
                                lineHeight: "0",
                              }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">
                                  Остаток предоплаченного исходящего
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {units?.outgoing ? (
                                    <span>
                                      {units?.outgoing?.toFixed(2)} Мб
                                    </span>
                                  ) : (
                                    <small
                                      style={{ fontWeight: 400, fontSize: 15 }}
                                    >
                                      Нет
                                    </small>
                                  )}
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell"></div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell"></div>
                              </td>
                            </tr>
                            {/* Входящий платный трафик */}
                            <tr
                              className="el-table__row"
                              style={{ background: "#dd876d", color: "black" }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">Входящий платный</div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {traffic?.trafficInc.toFixed(0)} Мб
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell">
                                  {traffic?.baseCostInc} ₽
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell">
                                  {traffic?.chargeInc} ₽
                                </div>
                              </td>
                            </tr>
                            {/* Исходящий платный трафик */}
                            <tr
                              className="el-table__row"
                              style={{ background: "#dd876d", color: "black" }}
                            >
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_23  "
                              >
                                <div className="cell">Исходящий платный</div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_24  "
                              >
                                <div className="cell">
                                  {traffic?.trafficOut.toFixed(0)} Мб
                                </div>
                              </td>

                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_26  "
                              >
                                <div className="cell">
                                  {traffic?.baseCostOut} ₽
                                </div>
                              </td>
                              <td
                                rowSpan={1}
                                colSpan={1}
                                className="el-table_7_column_27 is-right "
                              >
                                <div className="cell">
                                  {traffic?.chargeOut} ₽
                                </div>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                      <div
                        data-v-3563ec52=""
                        className="mt-3 flex justify-between align-center mb-4"
                      >
                        <div className="flex flex-column">
                          <p className="fa-md">Отчет за год</p>
                          <span>
                            <small data-v-3563ec52="">
                              Отчет будет направлен вам на почту в течении 2х часов
                            </small>
                          </span>
                        </div>
                        <div className="flex">
                          {isLoadedFullReport ? (
                            <button
                              data-v-3563ec52=""
                              type="button"
                              className="el-button el-button--primary el-button--small"
                              element-loading-text="Загрузка"
                              //onClick={getTraffic}
                            >
                              <span>
                                <small data-v-3563ec52="">Заказать</small>
                              </span>
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {isLoadedFullTraffic ? (
                      <div data-v-dde546dc="" className="el-main">
                        <div
                          data-v-dde546dc=""
                          className="dashboard justify-center align-center flex"
                        >
                          <TailSpin
                            color="rgb(18, 148, 160)"
                            height={100}
                            width={100}
                          />
                        </div>
                      </div>
                    ) : null}
                    {/* report div */}
                    {isOpenPrev ? (
                      <>
                        <div className="el-table__header-wrapper">
                          <table
                            cellSpacing="0"
                            cellPadding="0"
                            className="el-table__header"
                            style={{ width: "100%" }}
                          >
                            <colgroup>
                              <col
                                className="el-table_7_column_23"
                                width="345"
                              />
                              <col
                                className="el-table_7_column_24"
                                width="190"
                              />
                              {/* <col className="el-table_7_column_25" width="257" /> */}
                              <col
                                className="el-table_7_column_26"
                                width="325"
                              />
                              <col
                                className="el-table_7_column_27"
                                width="171"
                              />
                              <col className="gutter" width="0" />
                            </colgroup>
                            <thead className="has-gutter">
                              <tr className="">
                                <th
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_23 ascending    is-leaf is-sortable"
                                >
                                  <div className="cell">Трафик</div>
                                </th>
                                <th
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_24     is-leaf is-sortable"
                                >
                                  <div className="cell">Обьем</div>
                                </th>
                                <th
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_26     is-leaf"
                                >
                                  <div className="cell">Стоимость за МБ</div>
                                </th>
                                <th
                                  rowSpan={1}
                                  colSpan={1}
                                  className="el-table_7_column_27  is-right   is-leaf is-sortable"
                                >
                                  <div className="cell">Сумма</div>
                                </th>
                                <th
                                  className="gutter"
                                  style={{ width: 0, display: "none" }}
                                ></th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                        <div className="el-table__body-wrapper is-scrolling-none">
                          <table
                            cellSpacing="0"
                            cellPadding="0"
                            className="el-table__body"
                            style={{ width: 1030 }}
                          >
                            <colgroup>
                              <col
                                className="el-table_7_column_23"
                                width="300"
                              />
                              <col
                                className="el-table_7_column_24"
                                width="171"
                              />
                              <col
                                className="el-table_7_column_26"
                                width="257"
                              />
                              <col
                                className="el-table_7_column_27"
                                width="171"
                              />
                            </colgroup>

                            {prevTraffic.map((item: any) => (
                              <>
                                <p
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    textAlign: "left",
                                    fontSize: "18px",
                                    fontWeight: 300,
                                    width: "500%",
                                    background: "#f4fcf6",
                                    borderBottom: "1px solid #d6f1dc;",
                                    padding: "5px 10px 10px 10px",
                                    color: "#fff",
                                    backgroundColor: "#1294a0",
                                    borderColor: "#1294a0",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {item.date}
                                </p>
                                <tbody>
                                  <>
                                    {/* Входящий трафик */}
                                    <tr
                                      className="el-table__row"
                                      style={{
                                        background: "#d6f1dc",
                                        color: "black",
                                      }}
                                    >
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_23  "
                                      >
                                        <div className="cell">Входящий</div>
                                      </td>
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_24  "
                                      >
                                        <div className="cell">
                                          {item.traffic.incoming.toFixed(2)} Мб
                                        </div>
                                      </td>

                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_26  "
                                      >
                                        <div className="cell">0 ₽</div>
                                      </td>
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_27 is-right "
                                      >
                                        <div className="cell">0 ₽</div>
                                      </td>
                                    </tr>

                                    {/* Исходящий трафик */}
                                    <tr
                                      className="el-table__row"
                                      style={{
                                        background: "#d6f1dc",
                                        color: "black",
                                      }}
                                    >
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_23  "
                                      >
                                        <div className="cell">Исходящий</div>
                                      </td>
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_24  "
                                      >
                                        <div className="cell">
                                          {item.traffic.outgoing.toFixed(2)} Мб
                                        </div>
                                      </td>

                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_26  "
                                      >
                                        <div className="cell">0 ₽</div>
                                      </td>
                                      <td
                                        rowSpan={1}
                                        colSpan={1}
                                        className="el-table_7_column_27 is-right "
                                      >
                                        <div className="cell">0 ₽</div>
                                      </td>
                                    </tr>
                                  </>
                                </tbody>
                              </>
                            ))}
                          </table>
                        </div>
                      </>
                    ) : null}

                    {/* end report div */}
                    <h1>{errors}</h1>
                    <div
                      className="el-table__column-resize-proxy"
                      style={{ display: "none" }}
                    ></div>
                  </div>
                </div>
                <div className="el-loading-mask" style={{ display: "none" }}>
                  <div className="el-loading-spinner">
                    <svg viewBox="25 25 50 50" className="circular">
                      <circle
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        className="path"
                      ></circle>
                    </svg>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ReportTraffic;
